import { render, staticRenderFns } from "./Science.vue?vue&type=template&id=6919a7f5"
import script from "./Science.vue?vue&type=script&lang=js"
export * from "./Science.vue?vue&type=script&lang=js"
import style0 from "./Science.vue?vue&type=style&index=0&id=6919a7f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsButton: require('/opt/build/repo/components/Elements/Button.vue').default,ElementsSlider: require('/opt/build/repo/components/Elements/Slider.vue').default,ElementsModal: require('/opt/build/repo/components/Elements/Modal.vue').default})
